import either from "crocks/pointfree/either"
import constant from "crocks/combinators/constant"

export const isJust = either(constant(false), constant(true))
export const isNothing = either(constant(true), constant(false))
